'use es6';

import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getShouldShowGrid, getGridPositions } from 'InpageEditorUI/redux/selectors/layoutSectionDndSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const mapStateToProps = state => ({
  gridPositions: getGridPositions(state),
  shouldShowGrid: getShouldShowGrid(state)
});
class LayoutSectionGridContainer extends Component {
  constructor(props) {
    super(props);
    this.renderOutline = this.renderOutline.bind(this);
  }
  renderOutline(positionInfo, i) {
    const {
      top,
      left,
      height,
      width
    } = positionInfo;
    return /*#__PURE__*/_jsx("div", {
      className: "hs-ls-showing-grid-for-node updated-editor-styles",
      style: {
        top: Math.round(top),
        left: Math.round(left),
        width: Math.round(width),
        // Making the bottom edge of the outline one bigger solves _lots_ of grid doubling-up problems
        height: Math.round(height) + 1
      }
    }, `cell-outline-${i}`);
  }
  renderGutterLine(positionInfo, i) {
    const {
      top,
      left,
      height
    } = positionInfo;
    return /*#__PURE__*/_jsx("div", {
      className: "hs-ls-left-gutter-line",
      style: {
        top: Math.round(top),
        left: Math.round(left),
        height: Math.round(height)
      }
    }, `${i}-left-gutter-line`);
  }
  render() {
    const {
      gridPositions,
      shouldShowGrid
    } = this.props;
    const {
      cellPositions,
      rowPositions
    } = gridPositions;
    return /*#__PURE__*/_jsxs("div", {
      className: shouldShowGrid ? '' : 'hs-hide',
      children: [rowPositions.map(this.renderOutline), cellPositions.map(this.renderOutline)]
    });
  }
}
LayoutSectionGridContainer.propTypes = {
  gridPositions: PropTypes.object.isRequired,
  shouldShowGrid: PropTypes.bool.isRequired
};
export default connect(mapStateToProps)(LayoutSectionGridContainer);